import { Box } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { CoverOption, Quote } from '../../../domain'
import { TKey } from '../../../infrastructure/internationalisation'
import { AddOnBoolean } from './AddOnBoolean'

interface AddOnsMainProps {
  quote: Quote
  coverOptions: CoverOption[]
  onChange: (cover: CoverOption) => void
  default?: boolean
}

const tKey = TKey('components.add-on-selector')

export const AddOnSelector: FunctionComponent<AddOnsMainProps> = ({
  quote,
  coverOptions,
  onChange,
}) => {
  const addOns = coverOptions.map((coverOption) => (
    <AddOnBoolean
      tKey={tKey}
      key={coverOption.coverOption}
      quote={quote}
      coverOption={coverOption}
      onChange={onChange}
    />
  ))

  return <Box width={1}>{addOns}</Box>
}
